import { Service } from "../../../glue/Kernel.js";
import { createAudio } from "./audio.js";
import { resolveGainKey } from "./gain.js";
import { WEAPONS } from "../../../content/index.js";
import AUDIO from "../../../../data/audio.json" with { type: "json" };

// The client's sound: music bus, positional sfx, and the synth jetpack roar — all held
// in the audio object this wraps (audio.js). It needs nothing from siblings and is read
// from the moment the page loads (the lobby sliders, the join gesture), so it's built in
// the constructor. RenderService plays sfx through it, UIService drives its volumes.
export class AudioService extends Service {
    constructor() {
        super();
        this.audio = createAudio(AUDIO);
        // The sounds `/set gain:<sound>` can tune: every mapped sfx, plus the synth "jet".
        this.gainSounds = new Set([...Object.keys(AUDIO.sfx?.map || {}), "jet"]);
    }

    // The music bus follows the server's shared playlist: on each music cue (and each ping,
    // which sharpens the clock estimate) seek our player to the timeline the DJ broadcasts.
    on_phase_consolidate() {
        this.net = this.serviceAPI.require("net");
        this.net.on("net.music", (_n, _m, music) => this.audio.syncMusic(music.i, music.startedAt, this.net.client.serverOffset || 0));
    }

    // Direct passthroughs to the pieces callers reach by name.
    resume() { this.audio.resume(); }
    startBgm() { this.audio.startBgm(); }
    playSfx(name, atten = 1) { this.audio.playSfx(name, atten); }
    jetThrust(atten = 1) { this.audio.jetThrust(atten); }

    // A bus volume (bgm/sfx): read with n == null, otherwise set. Backs the console's
    // /volume and the lobby sliders.
    volume(bus, n) { return n == null ? this.audio.getVol(bus) : this.audio.setVol(bus, n); }

    // Per-sound gain by audio.json key OR weapon name (mapped to its sfx). Read with
    // n == null, set otherwise; null for an unknown sound so the console can say so.
    gain(token, n) {
        const key = resolveGainKey(token, WEAPONS, this.gainSounds);
        if (key == null) return null;
        return n == null ? this.audio.getGain(key) : this.audio.setGain(key, n);
    }
}
